// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ThresholdTable__small_text___2j4br{font-size:0.7rem}.ThresholdTable__jsonFont___1-scV{font-family:Consolas, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New !important;word-break:break-word}.ThresholdTable__jsonButton___ojfXx{color:#029aff !important;text-decoration:underline}.ThresholdTable__languageTitle___1cZKl{font-size:1.5rem;line-height:2}.ThresholdTable__container___1GMXT{padding-bottom:4px;padding:12px;padding-top:0}.ThresholdTable__containerTitle___Jkjjf{padding:4px;font-size:12px;margin-bottom:4px;font-weight:600;color:#666;padding-top:0}\n", ""]);
// Exports
exports.locals = {
	"small_text": "ThresholdTable__small_text___2j4br",
	"jsonFont": "ThresholdTable__jsonFont___1-scV",
	"jsonButton": "ThresholdTable__jsonButton___ojfXx",
	"languageTitle": "ThresholdTable__languageTitle___1cZKl",
	"container": "ThresholdTable__container___1GMXT",
	"containerTitle": "ThresholdTable__containerTitle___Jkjjf"
};
module.exports = exports;
